<script setup lang="ts">
import { CheckIcon, CardIcon } from "@/Components/Icons";

import { capitalizeFirstLetter } from "@/Utils/CapitalizeFirstLetter";

export interface TcPaymentCardProps {
  text?: string;
  selected?: boolean;
}

defineProps<TcPaymentCardProps>();
</script>

<template>
  <div class="tc_payment_card">
    <div class="tc_payment_card__container">
      <CardIcon class="tc_payment_card__container__icon" />
      <p>{{ capitalizeFirstLetter(text) }}</p>
    </div>

    <CheckIcon v-if="selected" class="tc_payment_card__check" color="content-high" />
  </div>
</template>

<style lang="scss" scoped>
.tc_payment_card {
  @include colors.color(content, low);
  @include sp.padding(false, 4);
  @include border(1, solid);
  @include colors.border(content, low);

  border-radius: $space-1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: $space-12;
  box-sizing: border-box;

  &:hover {
    cursor: pointer;
  }

  &__container {
    @include text.general(low, l);
    @include colors.color(content, high);

    display: flex;
    align-items: center;
    justify-content: center;

    &__icon {
      @include sp.margin(r, 2);

      width: $space-5;
    }

    &__text {
      text-transform: capitalize;
    }
  }
}
</style>
